import notify from "devextreme/ui/notify";
import axios from "../../api/axiosInctance";
import { guest } from "../../store/reducers/user/auth";
export const sleep = async (msec = 3000) => {
  return new Promise((resolve) => setTimeout(resolve, msec));
};
//const getToken1 = localStorage.getItem("token");
export const driverDataCall = async (filter) => {
  try {
    let newFilter = {};
    Object.keys(filter).map((key) => {
      if (filter[key] !== null) {
        newFilter[key] = filter[key];
      }
    });
    const getDriverData = await axios
      .post("/company/driver/list", newFilter)
      .then((res) => {
        // console.log(res);
        if (res.data.status.code === 200) {
          return res.data;
        }
      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined" ? err.response.data : err.message;
        //  console.log(message.status.message);
        const data = {
          status: { code: 400, message: message.status.message },
        };
        return data;
      })
      .finally(() => {
        // console.log("ddd");
      });
    return getDriverData;
  } catch (error) {
    console.log(error);
  }
};
// export const driverDataCall = async (filter) => {
//   try {
//     //console.log(axios);
//     let newFilter = {};
//     Object.keys(filter).map((key) => {
//       if (filter[key] !== null) {
//         newFilter[key] = filter[key];
//       }
//     });
//     // console.log(JSON.stringify(newFilter));
//     const getDriverData = await axios
//       .get("/driver/getDrivers", {
//         params: {
//           pagesize: 1000,
//           filter: JSON.stringify(newFilter),
//         },
//       })
//       .then((res) => {
//         //console.log(res.data);
//         return res.data;
//       })
//       .catch((err) => {
//         console.log("Aldaaa");
//         let message =
//           typeof err.response !== "undefined"
//             ? err.response.data.message
//             : err.message;
//         console.warn("error", message);
//       })
//       .finally(() => {
//         // console.log("ddd");
//       });
//     return getDriverData;
//   } catch (error) {
//     console.log(error);
//   }
// };
export const driverRemove = async (data) => {
  try {
    //console.log(axios);

    // console.log(JSON.stringify(newFilter));
    const responseData = await axios
      .post("company/driver/delete", data)
      .then((res) => {
        //console.log(res.data);
        return res.data;
      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined" ? err.response.data : err.message;
        //  console.log(message.status.message);
        const data = {
          status: { code: 400, message: message.status.message },
        };
        return data;
      })
      .finally(() => {
        // console.log("ddd");
      });
    return responseData;
  } catch (err) {
    let message =
      typeof err.response !== "undefined" ? err.response.data : err.message;
    //  console.log(message.status.message);
    const data = {
      status: { code: 400, message: message.status.message },
    };
    return data;
  }
};

export const createDriverService = async (formData) => {
  try {
    //   console.log(plateNo);

    const response = await axios
      .post("/company/driver/edit", formData)
      .then((res) => {
        // console.log(res.data);
        return res.data;
      })
      .catch((err) => {
        //console.log("Aldaaa");
        let message =
          typeof err.response !== "undefined" ? err.response.data : err.message;
        //  console.log(message.status.message);
        const data = {
          status: { code: 400, message: message.status.message },
        };
        return data;
        // notify(
        //   {
        //     message: message.status.message,
        //     width: 450,
        //   },
        //   "error",
        //   8000
        // );
        //  return res.data;
      })
      .finally(() => {
        // console.log("ddd");
      });
    return response;
  } catch (err) {
    let message =
      typeof err.response !== "undefined" ? err.response.data : err.message;
    //  console.log(message.status.message);
    const data = {
      status: { code: 400, message: message.status.message },
    };
    return data;
  }

  // console.log(ddd);
  //const guestToken = localStorage.getItem("guestToken");
  // return guestToken;
};
export const inspectionCall = async ({ plate_no }) => {
  try {
    //console.log(axios);

    const getInspection = await axios
      .post("/driver/inspection", plate_no)
      .then((res) => {
        //  console.log(res.data);
        return res.data;
      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined" ? err.response.data : err.message;
        //  console.log(message.status.message);
        const data = {
          status: { code: 400, message: message.status.message },
        };
        return data;
      })
      .finally(() => {
        // console.log("ddd");
      });
    return getInspection;
  } catch (err) {
    let message =
      typeof err.response !== "undefined" ? err.response.data : err.message;
    //  console.log(message.status.message);
    const data = {
      status: { code: 400, message: message.status.message },
    };
    return data;
  }

  // console.log(ddd);
  //const guestToken = localStorage.getItem("guestToken");
  // return guestToken;
};
export const driverSearchCall = async ({ regnum }) => {
  try {
    //console.log(axios);

    const getInspection = await axios
      .post("driver/data", regnum)
      .then((res) => {
        //  console.log(res.data);
        return res.data;
      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined" ? err.response.data : err.message;
        //  console.log(message.status.message);
        const data = {
          status: { code: 400, message: message.status.message },
        };
        return data;
      })
      .finally(() => {
        // console.log("ddd");
      });
    return getInspection;
  } catch (err) {
    let message =
      typeof err.response !== "undefined" ? err.response.data : err.message;
    //  console.log(message.status.message);
    const data = {
      status: { code: 400, message: message.status.message },
    };
    return data;
  }

  // console.log(ddd);
  //const guestToken = localStorage.getItem("guestToken");
  // return guestToken;
};
